// Date => DD-MM-YYYY
export const formatDate = (date) => {
  if (!date) return "-";

  return new Date(date)
    .toLocaleDateString("en-GB")
    .replace(/\//g, "-");
};

// Date & Time => DD-MM-YYYY HH:MM AM/PM
export const formatDateTime = (date) => {
  if (!date) return "-";

  const d = new Date(date);

  const formattedDate = d
    .toLocaleDateString("en-GB")
    .replace(/\//g, "-");

  const formattedTime = d.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return `${formattedDate} ${formattedTime}`;
};

// Currency => ₹90,000.00
export const formatCurrency = (amount) => {
  return Number(amount || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};